module.exports = __webpack_public_path__ + "img/83400.34c57d82.jpg";